// Shared sort key for kanban board lists (Kanban dashboard "Recent Boards" and
// the Admin KanbanWidget "Your Boards" list).
//
// Falls back updatedAt -> lastModified -> createdAt because the fields are
// populated unevenly across board generations: createBoard only started
// writing createdAt/updatedAt on 2026-06-11, while card activity writes
// lastModified (legacy) and updatedAt (current). Sorting by updatedAt alone
// buried any board without card activity below the top-N cut, so members
// concluded their new private boards "didn't save" (Tanya/Allay 2026-06-11).
//
// Handles Firestore Timestamp ({toDate()}), serialized timestamps ({seconds}),
// plain Date, and ISO strings; boards with no timestamps sort last (0), and
// unparseable values can never produce NaN (getTime() || 0).
//
// Mirrored in cypress/node-tests/kanban-recent-boards.test.js (node tests
// can't import src/ ESM) — keep the mirror in sync with any change here.
export function boardSortKey(board) {
    const raw = board.updatedAt || board.lastModified || board.createdAt || 0;
    const v = raw?.toDate?.() || (raw?.seconds ? new Date(raw.seconds * 1000) : raw);
    return new Date(v).getTime() || 0;
}
